import { Box, Tab, Tabs } from '@mui/material';
import { Link } from 'react-router-dom';

import useRouteMatch from '../../../hooks/useRouteMatch';

interface SettingsTabsProps {
  label: string;
  path: string;
}

interface LinkTabsProps {
  settingsTabs: SettingsTabsProps[];
}

const LinkTabs = (props: LinkTabsProps) => {
  const { settingsTabs } = props;
  const routeMatch = useRouteMatch(settingsTabs.map(({ path }) => path));
  const currentTab = routeMatch?.pattern?.path;

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={currentTab || false} >
        {settingsTabs.map(({ label, path }) => (
          <Tab
            key={path}
            label={label}
            value={path}
            to={path}
            component={Link}
          />
        ))}
      </Tabs>
    </Box>
  );
};
export default LinkTabs;
